module.exports = __webpack_public_path__ + "img/004-vitamins.30b36155.svg";